import { Component, OnInit } from '@angular/core';
import { FormGroup,FormBuilder, Validators, FormControl } from '@angular/forms';

import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { Image } from '../../../../../images/images'
import { VideoService } from 'src/app/shared/API-Service/services/video.service';
import { VideoAlbumService } from 'src/app/shared/API-Service/services/video-album.service';



@Component({
  selector: 'app-insert-video',
  templateUrl: './insert-video.component.html',
  styleUrls: ['./insert-video.component.css']
})
export class InsertVideoComponent implements OnInit {
  recordtoupdate: any;
  videoes:any ;
  videoForm:FormGroup;
  update:boolean = false;
  button:boolean = false;
  constructor(private _VideoService:VideoService,private _Router:Router,private _FormBuilder:FormBuilder,private _VideoAlbumService:VideoAlbumService) { }

  ngOnInit(): void {
    this.initiate();
    this.getvideoalbum();
    this.checkEdit();
  }

  initiate(){
    this.videoForm = this._FormBuilder.group({
      title: [''],
      titleAr: ['', Validators.required],
      youtubeVideoUrl:['', [Validators.required , Validators.pattern(`((http|https)://)(www.)[a-zA-Z0-9.]{1,}(/){1}(.*)`)]],
      videoAlbumId:['', Validators.required],
    
    });
  }
  getvideoalbum(){
    this._VideoAlbumService.GetVideoAlbum().subscribe((res) => {
      this.videoes = res.data ;
     })
  }
 
  get fc() {
    return this.videoForm.controls;
  }
  checkEdit() {
    this._VideoService.Data.subscribe((res) => {
      if (res != null) {
        this.videoForm = this._FormBuilder.group({
          title: [res.title],
          titleAr: [res.titleAr, Validators.required],
          youtubeVideoUrl: [res.youtubeVideoUrl, [Validators.required , Validators.pattern(`((http|https)://)(www.)[a-zA-Z0-9.]{1,}(/){1}(.*)`)]], 
          videoAlbumId: [res.videoAlbumId, Validators.required], 
        
        });
        this.update = true;
        this.recordtoupdate = res ;
      
      } else {
      }
     
    });
  }
  onSubmit(){
    this.button = true;
   if(this.update == false && this.videoForm.status == "VALID"){
    this._VideoService.CreateVideo(this.videoForm.value).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم الحفظ بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });
      this.videoForm.reset();
      this._Router.navigate(['/content/admin/ViewVideo']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.error.message    
      }) 
      this.button = false ;
    }, () => {
    })
   } else if(this.videoForm.status == "VALID"){
    this.videoForm.addControl('Id', new FormControl(this.recordtoupdate.id, Validators.required));
    this._VideoService.UpdateVideo(this.videoForm.value).subscribe((res) => {
      Swal.fire({
        icon: "success",
        title: "تم التعديل بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });
      this.videoForm.reset();
      this._Router.navigate(['/content/admin/ViewVideo']);
    },(err) => {
      Swal.fire({
        icon: 'error',
        title: 'خطأ',
        text:err.error.message    
      }) 
    }, () => {
    })
   }else {
    Swal.fire({
      icon: 'error',
      title: 'خطأ',
      text:"بالرجاء التأكد من ملئ جميع الحقول"   
    })
    this.videoForm.markAllAsTouched();
    this.button = false;
   }
  }
  ngOnDestroy(){
    this._VideoService.Data.next(null);
     }
}
